<template>
  <div class="is-fullhd">
    <div class="box">
      <div class="content has-text-centered">
        <h2 class="is-title is-bold has-text-centered has-text-primary">
          Manage Client(s)
        </h2>
      </div>
      <hr></hr>
      <div class="content">
        <a class="button is-link" @click="showForm = !showForm">Add New Client</a>
      </div>
      <div class="section" v-show="showForm" style="padding: 1rem 1rem 3rem 1rem;">
        <form id="formValue">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">Client Information</label>
                <div class="control">
                  <input class="input" v-model="client.companyName" type="text" placeholder="Client Name" required>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <input class="input" v-model="client.url" type="text" placeholder="Website URL">
                </div>
              </div>
              <div class="field">
                <div class="file is-primary has-name is-fullwidth is-right">
                  <label class="file-label">
                    <input class="file-input" v-on:change="fileChange()" type="file" name="logo" id="logo">
                    <span class="file-cta">
                      <span class="file-icon">
                        <i class="fa fa-upload"></i>
                      </span>
                      <span class="file-label">
                        upload logo
                      </span>
                    </span>
                    <span class="file-name" style="background: #fff; max-width: 6em !important;">
                      {{ pictureName ? pictureName : 'Client Logo'}}
                    </span>
                  </label>
                </div>
                 <p class="help">Minimum size: width 200px * height 40px</p>
              </div>
            </div>

            <div class="column">
              <div class="field">
                <label class="label">Contact Person</label>
                <div class="control">
                  <input class="input" v-model="client.firstName" type="text" placeholder="First Name" required>
                </div>
                <div class="control">
                  <input class="input" v-model="client.lastName" type="text" placeholder="Last Name" required>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <input class="input" v-model="client.email" type="text" placeholder="Email" required>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <input class="input" v-model="client.phone" type="text" placeholder="Phone">
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <input class="input" v-model="client.userRole" type="text" placeholder="Role">
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <input class="input" v-model="client.password" type="password" placeholder="Password" required>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <input class="input" type="password" placeholder="Confirm Password" required>
                </div>
              </div>
            </div>
          </div>
          <div class="field is-grouped is-pulled-right">
            <div class="control">
              <button class="button is-primary" @click.prevent="addClient()">Submit</button>
            </div>
            <div class="control">
              <button class="button is-light" @click="showForm = !showForm">Cancel</button>
            </div>
          </div>
        </form>
      </div>
      <div class="content" v-if="clients.length > 0">
        <div class="table-responsive">              
          <table class="table is-bordered is-striped is-narrow">
            <thead>
              <tr>
                <!-- <th>SL</th> -->
                <th colspan="9">Client Name</th>
              </tr>
            </thead>
            <tbody>
              <tr class="list-group-item" v-for="(item,index) in clients">
                <!-- <td class="is-icon" style="width:30px;">
                  {{index}}
                </td> -->
                <td colspan="5">
                  <span class="name">
                    <a href="#/teamInfo">{{item.companyName}}</a>
                  </span>
                </td>
                <td class="is-icon" style="width:30px;">
                  <button class="button is-primary is-small" @click="openModal(item)">
                    <i class="fa fa-pencil-square-o"> Edit</i>
                  </button>
                </td>
                <td class="is-icon" style="width:30px;">
                  <button class="button is-danger is-small">
                    <i class="fa fa-trash" @click="deleteClient(item)"> Delete</i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
      
    <div class="modal" :class="{ isActive: modalOpen }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Edit Client</p>
          <button class="delete" aria-label="close" @click="closeModal()"></button>
        </header>
        <section class="modal-card-body">
          <div class="section" style="padding: 1rem 1rem 3rem 1rem;">
            <form id="formValue">
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label">Client Information</label>
                    <div class="control">
                      <input class="input" v-model="onEditClient.companyName" type="text" placeholder="Client Name">
                    </div>
                  </div>
                  <div class="field">
                    <div class="control">
                      <input class="input" v-model="onEditClient.websiteURL" type="text" placeholder="Website URL">
                    </div>
                  </div>
                  <div class="field">
                    <div class="file is-primary has-name is-fullwidth is-right">
                      <label class="file-label">
                        <input class="file-input" v-on:change="fileChange2()" type="file" name="logo2" id="logo2">
                        <span class="file-cta">
                          <span class="file-icon">
                            <i class="fa fa-upload"></i>
                          </span>
                          <span class="file-label">
                            upload a logo…
                          </span>
                        </span>
                        <span class="file-name" style="background: #fff; max-width: 6em !important;">
                          {{ pictureName2 ? pictureName2 : 'Client Logo'}}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">Contact Person</label>
                    <div class="control">
                      <input class="input" v-model="onEditClient.contactPerson.firstName" type="text" placeholder="First Name">
                    </div>
                    <div class="control">
                      <input class="input" v-model="onEditClient.contactPerson.lastName" type="text" placeholder="Last Name">
                    </div>
                  </div>
                  <div class="field">
                    <div class="control">
                      <input class="input" v-model="onEditClient.contactPerson.role" type="text" placeholder="Role">
                    </div>
                  </div>
                  <div class="field">
                    <div class="control">
                      <input class="input" v-model="onEditClient.contactPerson.email" type="text" placeholder="Email" readonly>
                    </div>
                  </div>
                  <div class="field">
                    <div class="control">
                      <input class="input" v-model="onEditClient.contactPerson.phone" type="text" placeholder="Phone">
                    </div>
                  </div>
                </div>
              </div>
              <div class="field is-grouped is-pulled-right">
                <div class="control">
                  <button class="button is-success" @click.prevent="editClient()">Save changes</button>
                </div>
              </div>
            </form>
          </div>
        </section>
        <footer class="modal-card-foot">
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as globalConstants from '../../globalConstants.js'
import FormData from 'form-data'
export default {
  components: {
  },
  data () {
    return {
      modalOpen: false,
      onEditClient: {
        contactPerson: {},
        address: {}
      },
      client: {
        companyName: '',
        firstName: '',
        lastName: '',
        clientTitle: '',
        email: '',
        userRole: '',
        phone: '',
        country: '',
        city: '',
        code: '',
        street: '',
        url: '',
        logoPath: ''
      },
      logo: '',
      pictureName: '',
      pictureName2: '',
      isSubmitted: false,
      displayMsg: '',
      showForm: false,
      clients: []
    }
  },
  mounted () {
  },
  created () {
    axios.get(globalConstants.apiURL + '/api/v1/clients')
    .then(response => {
      this.clients = response.data
      console.log(response)
    })
    .catch(error => {
      console.log(error)
    })
  },
  methods: {
    fileChange () {
      var image = document.getElementById('logo').files[0]
      this.pictureName = image.name
    },
    fileChange2 () {
      var image = document.getElementById('logo2').files[0]
      this.pictureName2 = image.name
    },
    openModal (item) {
      console.log(item)
      this.modalOpen = !this.modalOpen
      this.onEditClient = item
    },
    closeModal () {
      this.modalOpen = !this.modalOpen
    },
    editClient () {
      var image = document.getElementById('logo2').files[0]
      var fd = new FormData()
      fd.append('file', image, 'file')
      let index = this.clients.indexOf(this.onEditClient)
      axios.put(globalConstants.apiURL + '/api/v1/clients/' + this.onEditClient._id, this.onEditClient)
      .then(response => {
        // let index = this.clients.indexOf(item)
        this.clients[index] = response.data
        this.modalOpen = !this.modalOpen
        // console.log(response)
        if (image) {
          fd.append('clientId', true)
          axios.post(globalConstants.apiURL + '/api/v1/users/' + this.onEditClient._id + '/upload', fd, {
            headers: {'Content-Type': undefined}
          }).then(response => {
            console.log(response.data)
          })
          .catch(error => {
            console.log(error)
          })
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    deleteClient (item) {
      if (!window.confirm('Are you sure you want to delete the user?')) {
        return
      }
      axios.delete(globalConstants.apiURL + '/api/v1/clients/' + item._id)
      .then(response => {
        let index = this.clients.indexOf(item)
        this.clients.splice(index, 1)
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
    },

    addClient () {
      var image = document.getElementById('logo').files[0]
      var fd = new FormData()
      fd.append('file', image, 'file')
      axios.post(globalConstants.apiURL + '/api/v1/clients', {
        companyName: this.client.companyName,
        websiteURL: this.client.url,
        logoPath: this.client.logoPath,
        contactPerson: {
          firstName: this.client.firstName,
          lastName: this.client.lastName,
          email: this.client.email,
          role: this.client.userRole,
          phone: this.client.phone,
          password: this.client.password
        },
        address: {
          country: this.client.country,
          city: this.client.city,
          postalCode: this.client.code,
          street: this.client.street
        }
      })
      .then(response => {
        this.clients.push(response.data.client)
        if (image) {
          axios.post(globalConstants.apiURL + '/api/v1/users/' + response.data.userId + '/upload', fd, {
            headers: {'Content-Type': undefined}
          }).then(response => {
            console.log(response.data)
          })
          .catch(error => {
            console.log(error)
          })
        }
      })
      .catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.checkbox {
  display: block !important;
}

.isActive {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.modal {
  top: 75px !important;
  @media screen and (max-width: 999px) {
    top: 0px !important;
  }
}

.modal-card {
  max-height: calc(100vh - 175px) !important;
}

.modal-card-foot {
  justify-content: flex-end !important;
}

.name {
  color: #6666ff !important;
}
</style>



// WEBPACK FOOTER //
// admin.vue?3726df98